import Phaser from "phaser";
import { ArrowBtn } from "@phaser/ui/btns/ArrowBtn";

interface LeftBtnOptions {
  textureKey: string;
  onClick: () => void;
}

export class LeftBtn extends ArrowBtn {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: LeftBtnOptions,
  ) {
    super(scene, x, y, {
      textureKey: options.textureKey,
      direction: "LEFT",
      onClick: options.onClick,
    });
  }
}
